<template>
  <el-dialog
    :close-on-click-modal="false"
    title="充值"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="800px"
  >
    <section class="tableBox" v-loading="detailLoading">
      <p class="title">
        请使用绑定的尾号为{{bankcardDesc}}的银行卡，将金额转入以下账户：
      </p>
      <section class="infoBox">
        <p class="line">
          账户姓名：
          <span class="primary cur" @click="copy(accountInfo.acctName)">{{accountInfo.acctName}}</span>
        </p>
        <p class="line">
          银行账号：
          <span class="primary cur" @click="copy(accountInfo.acctNo)">{{accountInfo.acctNo}}</span>
        </p>
        <p class="line">
          开户省市：
          <span class="primary cur" @click="copy(accountInfo.bankProvCity)">{{accountInfo.bankProvCity}}</span>
        </p>
        <p class="line">
          开户银行：
          <span class="primary cur" @click="copy(accountInfo.bankName)">{{accountInfo.bankName}}</span>
        </p>
        <p class="line">
          开户支行：
          <span class="primary cur" @click="copy(accountInfo.branchName)">{{accountInfo.branchName}}</span>
        </p>
      </section>
      <el-alert
        :closable="false"
        title="转入后可提现金额即时增加，可用于加油、维修、支付欠款、提现使用。"
        type="warning" />
      <el-alert
        :closable="false"
        title="温馨提示：单笔充值超过5万，在工作日08:00-17:00之间充值实时到账，其余时间包括节假日充值在工作日的08:00后到账。单笔充值小于5万不受限制，预计实时到账，具体到账时间以银行为准。请合理安排充值。"
        type="warning" />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  getAccountRechargeMsg,
} from 'api/user';
import {
  copy,
} from '@qx/utils';
export default {
  data () {
    return {
      dialogFormVisible: false,
      detailLoading: false,
      originData: {},
      accountInfo: {},
    };
  },
  computed: {
    bankcardDesc () {
      const result = [];
      if (!this.originData.listData) {
        return '-';
      }
      this.originData.listData.forEach((item) => {
        if (item.isDefaultAcct === 1) {
          result.unshift((item.acctNo.substr(item.acctNo.length - 4)) + '【默认账户】');
        } else {
          result.push((item.acctNo.substr(item.acctNo.length - 4)));
        }
      });
      return result.join('、');
    },
  },
  methods: {
    copy,

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    async show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.originData = item;
      this.detailLoading = true;
      const res = await getAccountRechargeMsg({
        bankType: item.key === 'public' ? 1 : 0,
        personal: 1,
      });
      this.detailLoading = false;
      this.accountInfo = res;
    },
  },
};
</script>

<style scoped lang="scss">
.title{
  font-size: 16px;
  margin-bottom: 24px;
}
.infoBox{
  line-height: 24px;
  margin-bottom: 24px;
}
</style>
